module.exports = "<div class='loading-bar'>\n    <ng2-slim-loading-bar [color]=\"'#00C873'\" [height]=\"'5px'\"></ng2-slim-loading-bar>\n</div>\n<div class='block' *ngIf=\"show\" ></div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_shared/loader/loader.component.html
// module id = ./src/app/_shared/loader/loader.component.html
// module chunks = main